import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Fontes auto-hébergées : aucun appel à un CDN externe (charte, doc 06, § 4).
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource-variable/bodoni-moda';

import './styles/jetons.css';
import './styles/base.css';
import './styles/composants.css';

import { App } from './App';
import { FournisseurAuth } from './auth/contexte';

const racine = document.getElementById('racine');
if (!racine) throw new Error('Élément racine introuvable');

createRoot(racine).render(
  <StrictMode>
    <BrowserRouter>
      <FournisseurAuth>
        <App />
      </FournisseurAuth>
    </BrowserRouter>
  </StrictMode>,
);
